var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "well page"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v(_vm._s(_vm.store.name))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "showMsg"
    }
  }), _vm._v(" "), (!_vm.show_history) ? _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.toggle_history
    }
  }, [_vm._v("Request History "), _c('i', {
    staticClass: "glyphicon glyphicon-list-alt"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.new_job
    }
  }, [_vm._v("New Request "), _c('i', {
    staticClass: "glyphicon glyphicon-plus"
  })])]) : _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.toggle_history
    }
  }, [_vm._v("Unsubmitted Requests "), _c('i', {
    staticClass: "glyphicon glyphicon-list-alt"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.new_job
    }
  }, [_vm._v("New Request "), _c('i', {
    staticClass: "glyphicon glyphicon-plus"
  })])]), _vm._v(" "), (!_vm.show_history) ? _c('p', [_vm._v("Select a request to resume or start a new maintenance request.")]) : _c('p', [_vm._v("Below is a list of previously completed requests for your store. Select a request to see more details.")])]), _vm._v(" "), (!_vm.show_history) ? _c('div', {
    staticClass: "row"
  }, [_c('h4', [_vm._v("Unsubmitted Requests")])]) : _c('div', {
    staticClass: "row"
  }, [_c('h4', [_vm._v("Request History")])]), _vm._v(" "), (!_vm.show_history) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "padding-right": "0px !important"
    }
  }, [_c('ul', _vm._l((_vm.unsubmitted_jobs), function(job) {
    return _c('li', {
      class: {
        selected: _vm.selected_job == job
      }
    }, [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selected_job = job
        }
      }
    }, [_vm._v(_vm._s(_vm.format_time(job)))])])
  })), _vm._v(" "), (!_vm.unsubmitted_jobs.length) ? _c('strong', {
    staticClass: "text-danger"
  }, [_vm._v("No requests found")]) : _vm._e()]), _vm._v(" "), (_vm.selected_job != null) ? _c('div', {
    staticClass: "col-md-7 jobOverview"
  }, [_c('div', {
    staticClass: "overviewContent"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.delete_job(_vm.selected_job)
      }
    }
  }, [_vm._v("Delete Job "), _c('i', {
    staticClass: "glyphicon glyphicon-trash"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        _vm.resume_job(_vm.selected_job)
      }
    }
  }, [_vm._v("Resume Request "), _c('i', {
    staticClass: "glyphicon glyphicon-share-alt"
  })]), _vm._v(" "), _c('h4', [_vm._v("Total Issues:\n          "), _c('small', [_vm._v(_vm._s(_vm.job_issues.length))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "3em"
    }
  }, _vm._l((_vm.job_issues), function(issue) {
    return _c('div', {
      staticClass: "col-md-5 col-md-offset-1 panel panel-default"
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('b', [_vm._v("Type: " + _vm._s(_vm.issue_type_name(issue.type)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Description: " + _vm._s(issue.description))]), _vm._v(" "), _c('br'), _vm._v(" "), (issue.has_images) ? _c('i', {
      staticClass: "glyphicon glyphicon-picture"
    }) : _vm._e()])])
  }))])]) : _vm._e()]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "padding-right": "0px !important"
    }
  }, [_c('ul', _vm._l((_vm.submitted_jobs), function(job) {
    return _c('li', {
      class: {
        selected: _vm.selected_job == job
      }
    }, [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selected_job = job
        }
      }
    }, [_vm._v(_vm._s(_vm.format_time(job)))])])
  })), _vm._v(" "), (!_vm.submitted_jobs.length) ? _c('strong', {
    staticClass: "text-danger"
  }, [_vm._v("No historical requests found")]) : _vm._e()]), _vm._v(" "), (_vm.selected_job != null) ? _c('div', {
    staticClass: "col-md-7 jobOverview"
  }, [_c('div', {
    staticClass: "overviewContent"
  }, [_c('h4', [_vm._v("Total Issues:\n          "), _c('small', [_vm._v(_vm._s(_vm.job_issues.length))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "3em"
    }
  }, _vm._l((_vm.job_issues), function(issue) {
    return _c('div', {
      staticClass: "col-md-5 col-md-offset-1 panel panel-default"
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('b', [_vm._v("Type: " + _vm._s(_vm.issue_type_name(issue.type)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Description: " + _vm._s(issue.description))]), _vm._v(" "), _c('br'), _vm._v(" "), (issue.has_images) ? _c('i', {
      staticClass: "glyphicon glyphicon-picture"
    }) : _vm._e()])])
  }))])]) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4862efe1","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/vue/logger/StoreJobs.vue
// module id = 535
// module chunks = 0